<template>
  <div class="tutorial2-page">
    <div class="page-heading">
      <div>
        <h2>教程设置</h2>
        <p>管理您发布的教程内容</p>
      </div>
      <app-icon class="app-icon heading-icon" name="menu_book"></app-icon>
    </div>

    <section class="tutorial-panel">
      <div class="panel-header">
        <div>
          <h3>我的教程</h3>
          <p>发布视频教程或图文教程，帮助用户快速上手</p>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="$router.push('/user2/tutorial_edit')">
          新建教程
        </el-button>
      </div>

      <div class="table-wrap">
        <el-table :data="recordList" stripe size="small" v-loading="loadingRecord" empty-text="暂无教程"
          :header-cell-style="{ background: '#f8fafc', color: '#64748b', fontWeight: 500 }">
          <el-table-column prop="title" label="标题" min-width="180"></el-table-column>
          <el-table-column label="标签" min-width="180">
            <template slot-scope="scope">
              <el-tag v-for="tag in getTags(scope.row.tags)" :key="tag" size="mini" class="tutorial-tag">
                {{ tag }}
              </el-tag>
              <span v-if="getTags(scope.row.tags).length === 0" class="empty-cell">—</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'warning'" size="mini">
                {{ scope.row.status == 1 ? '已发布' : '私密' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="上传时间" width="170" :formatter="formatDate"></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap" v-if="recordTotal > 0">
        <span class="total-text">共 {{ recordTotal }} 条</span>
        <el-pagination small background layout="prev, pager, next" :page-size="10" :total="recordTotal"
          :current-page="recordPage" @current-change="loadRecords"></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'User2TutorialList',
  data() {
    return {
      recordList: [],
      recordPage: 1,
      recordTotal: 0,
      loadingRecord: false
    }
  },
  methods: {
    edit(row) {
      this.$router.push('/user2/tutorial_edit?id=' + row.id)
    },
    getTags(tags) {
      if (Array.isArray(tags)) return tags
      if (!tags) return []
      try {
        var parsed = JSON.parse(tags)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    loadRecords(page) {
      this.recordPage = page || 1
      this.loadingRecord = true
      this.$ajax.get('qhy/app/tutorial_list?ismy=1&page=' + this.recordPage).then(res => {
        if (res.data.status == 200) {
          var data = res.data.data || {}
          this.recordList = data.data || []
          this.recordTotal = data.total || 0
        } else {
          this.$msg.error(res.data.msg || '获取教程失败')
        }
        this.loadingRecord = false
      }).catch(() => {
        this.loadingRecord = false
        this.$msg.error('获取教程失败，请稍后重试')
      })
    },
    formatDate(row) {
      if (!row.time) return '—'
      var date = new Date(row.time * 1000)
      var pad = value => String(value).padStart(2, '0')
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' +
        pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds())
    }
  },
  created() {
    this.loadRecords(1)
  }
}
</script>

<style scoped>
.tutorial2-page {
  max-width: 1180px;
  margin: 0 auto;
  color: #1e293b;
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.page-heading h2 {
  margin: 0;
  font-size: 24px;
  color: #0f172a;
}

.page-heading p,
.panel-header p {
  margin: 8px 0 0;
  color: #94a3b8;
  font-size: 13px;
}

.heading-icon {
  color: #1a73e8;
  font-size: 30px;
}

.tutorial-panel {
  padding: 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.panel-header h3 {
  margin: 0;
  color: #1e293b;
  font-size: 18px;
}

.table-wrap {
  overflow-x: auto;
}

.tutorial-tag {
  margin: 2px 4px 2px 0;
}

.empty-cell {
  color: #94a3b8;
}

.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-height: 40px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #eef2f7;
}

.total-text {
  color: #64748b;
  font-size: 13px;
}

@media (max-width: 640px) {
  .tutorial2-page {
    padding: 0 2px;
  }

  .page-heading {
    margin-bottom: 14px;
  }

  .page-heading h2 {
    font-size: 20px;
  }

  .tutorial-panel {
    padding: 16px 12px;
    border-radius: 12px;
  }

  .panel-header {
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .panel-header p {
    line-height: 1.5;
  }

  .pagination-wrap {
    justify-content: center;
    gap: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/TutorialList.vue